import events from 'pricing-pages-ui/events.yaml';
import { APP } from 'pricing-pages-ui/constants/tracking/App';
import Raven from 'raven-js';
export default {
  events,
  properties: {
    namespace: APP
  },
  lastKnownEventProperties: ['screen', 'tab', 'isSeatsPilot'],
  onError: err => {
    Raven.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  }
};